import { useState } from "react";
import { useRef } from "react";
import { toast } from "react-toastify";
import { ModalBody, ModalFooter } from "reactstrap";
import carBrands from "../../../../../consts/CarBrands";
import ReactSelect from "react-select";
import { createCar } from "../../../../../services/CarService";

const FormVehicle = (props) => {
  const addButton = useRef("");
  const [loading, setLoading] = useState(false);
  const [vehicleBrand, setVehicleBrand] = useState();
  const [inputLicensePlate, setInputLicensePlate] = useState(
    props.licensePlate,
  );
  const [inputVehicleColor, setInputVehicleColor] = useState("");
  const [inputVehicleModel, setInputVehicleModel] = useState("");
  const regexLicensePlate = "^.{7}$";

  function handleSubmitVehicleForm(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      vehicleModel: inputVehicleModel,
      vehicleBrand: vehicleBrand.key,
      licensePlate: inputLicensePlate,
      vehicleColor: inputVehicleColor,
    };

    createCar(data)
      .then((response) => {
        toast.success("Veículo cadastrado");
        props.findVehicle(data.licensePlate);
        setLoading(false);
        props.close();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        if (error.response && error.response.status)
          toast.error(error.response.data);
        else toast.error("Não foi possivel cadastrar veículo");
      });
  }

  return (
    <form onSubmit={handleSubmitVehicleForm} className="w-100">
      {/* SEÇÃO ÚNICA: DADOS DO VEÍCULO (Sem paddings extras que esmagam o card) */}
      <div className="bg-light p-3 rounded-4 border w-100 mt-2">
        <div className="d-flex align-items-center mb-3 text-primary">
          <i className="fas fa-car me-2"></i>
          <span className="fw-bold text-muted small text-uppercase">Informações do Veículo</span>
        </div>

        {/* Row g-2 para garantir que os campos caibam alinhados com o card superior */}
        <div className="row g-2">
          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Placa <span className="text-danger">*</span></label>
            <input
              onChange={(e) => setInputLicensePlate(e.target.value)}
              value={inputLicensePlate}
              className="form-control form-control-lg fw-bold text-uppercase border-2 bg-white"
              style={{ letterSpacing: '2px' }}
              pattern={regexLicensePlate}
              maxLength={7}
              placeholder="Ex: ABC1D23"
              required
            />
          </div>

          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Marca <span className="text-danger">*</span></label>
            {/* Lógica original de options e props preservada */}
            <ReactSelect
              id="selectBrand"
              name="brands"
              classNamePrefix="select"
              onChange={(brand) => setVehicleBrand(brand)}
              value={vehicleBrand}
              options={carBrands.map((brand, index) => ({
                value: brand.replace("_", " "),
                key: brand,
                label: brand.replace("_", " "),
              }))}
              placeholder="Ex: Ford..."
              required
              styles={{ control: (b) => ({ ...b, borderRadius: '8px', minHeight: '48px' }) }}
            />
          </div>

          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Modelo <span className="text-danger">*</span></label>
            <input
              id="carModel"
              value={inputVehicleModel}
              onChange={(e) => setInputVehicleModel(e.target.value)}
              type="text"
              className="form-control form-control-lg fs-6 border-2"
              placeholder="Ex: Gol"
              required
            />
          </div>

          <div className="col-lg-3">
            <label className="form-label small fw-bold text-dark">Cor</label>
            <input
              value={inputVehicleColor}
              onChange={(e) => setInputVehicleColor(e.target.value)}
              className="form-control form-control-lg fs-6 border-2"
              placeholder="Ex: Preto"
            />
          </div>
        </div>
      </div>

      {/* FOOTER DIRETAMENTE NO FORM (Sem ModalFooter para não criar margens duplas) */}
      <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end mt-4 px-1">
        {!loading ? (
          <>
            <button
              ref={addButton}
              type="submit"
              className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm order-0 px-sm-5"
              style={{ minWidth: '180px' }}
            >
              <i className="fas fa-car me-2"></i> Salvar Veículo
            </button>

            <button
              type="button"
              onClick={() => props.close()}
              className="btn btn-outline-danger btn-lg rounded-3 border-2 order-1"
            >
              Cancelar
            </button>
          </>
        ) : (
          <div className="w-100 text-center py-2">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        )}
      </div>
    </form>
  );
};

export default FormVehicle;
